'use client';
import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqs = [
  {
    id: 'faq-1',
    q: 'Is Brain Basket free to use?',
    a: 'Yes! Brain Basket offers hundreds of free quizzes, games, and challenges with XP rewards and badges. Paid competitions with cash prizes are optional and only available in eligible regions to verified users.',
  },
  {
    id: 'faq-2',
    q: 'How do I withdraw my winnings?',
    a: 'Verified users can withdraw winnings to their bank account, UPI, PayPal, or other supported methods. Withdrawals undergo a compliance review (typically 24–72 hours) before processing. Minimum withdrawal amounts and methods vary by region.',
  },
  {
    id: 'faq-3',
    q: 'Are competitions fair? How do you prevent cheating?',
    a: 'Brain Basket uses server-authoritative scoring, signed game events, bot detection, and a Fair Play Engine. Game outcomes are never determined client-side. Our fraud team monitors for collusion, account sharing, and impossible performance patterns.',
  },
  {
    id: 'faq-4',
    q: 'What is the platform fee?',
    a: 'Brain Basket charges a 10% service fee on paid competition prize pools. This fee is displayed clearly before you confirm your entry. Free competitions have no fees. Creator-hosted challenges may have different fee structures disclosed upfront.',
  },
  {
    id: 'faq-5',
    q: 'What age is required to participate in paid competitions?',
    a: 'You must be at least 18 years old (or the legal age in your jurisdiction) to participate in paid competitions or deposit funds. Age is verified during the KYC process. Under-18 users can access all free activities without restriction.',
  },
  {
    id: 'faq-6',
    q: 'Which countries are supported?',
    a: 'Brain Basket is available in 78 countries. Free activities are available globally. Paid competitions, deposits, and withdrawals are subject to regional compliance rules. Some features may be restricted in certain jurisdictions.',
  },
];

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>('faq-1');

  return (
    <section className="landing-section" style={{ background: 'rgba(17, 24, 39, 0.3)' }}>
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold uppercase tracking-widest mb-3 block" style={{ color: '#A78BFA' }}>Common Questions</span>
          <h2 className="font-extrabold" style={{ fontSize: 'clamp(24px, 3.5vw, 42px)', letterSpacing: '-0.02em' }}>
            Frequently Asked <span className="text-gradient-primary">Questions</span>
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs?.map((faq) => (
            <div key={faq?.id}
              className="rounded-xl overflow-hidden transition-all"
              style={{ background: 'var(--card)', border: `1px solid ${openId === faq?.id ? 'rgba(124, 58, 237, 0.4)' : 'var(--border)'}` }}>
              <button
                onClick={() => setOpenId(openId === faq?.id ? null : faq?.id)}
                className="w-full flex items-center justify-between p-5 text-left"
              >
                <span className="text-base font-semibold text-foreground pr-4">{faq?.q}</span>
                {openId === faq?.id
                  ? <ChevronUp size={18} style={{ color: '#A78BFA', flexShrink: 0 }} />
                  : <ChevronDown size={18} style={{ color: 'var(--muted-foreground)', flexShrink: 0 }} />
                }
              </button>
              {openId === faq?.id && (
                <div className="px-5 pb-5 border-t" style={{ borderColor: 'var(--border)' }}>
                  <p className="text-sm leading-relaxed pt-4" style={{ color: 'var(--muted-foreground)' }}>{faq?.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}